import React, { useEffect, useState } from 'react'

import './styles/posts.css'


/* BASE_URL
 * used to fetch posts from GitHub
 */
const BASE_URL = 'https://raw.githubusercontent.com/psychdotcat/psychdotcat.github.io/refs/heads/gh-pages/posts'


const fetchPosts = async (baseUrl, index, batchSize = 5, prefix = 'post-', extension = '.json') => {
  let posts = []
  let count = 0

  while (true) {
    const url = `${baseUrl}/${prefix}${index}${extension}`
    console.log(`Fetching: ${url}`)

    if ( index <= 0 || count >= 5 ) {
      break
    }

    try {
      const response = await fetch(url)

      if (response.status === 404) {
        console.log(`No more posts after index ${index - 1}`)
        break
      }

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      const data = await response.json()
      posts.push(data)
      index = index - 1
      count += 1
    } catch (error) {
      console.error(`Error fetching ${url}: `, error)
      break
    }
  }

  return posts
}


const Posts = () => {

  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingIndex, setLoadingIndex] = useState(22) // number of posts

  useEffect(() => {
    setLoading(true)
    fetchPosts(BASE_URL, loadingIndex)
      .then(data => {
        setLoadingIndex(index => index - 5)
        setLoading(false)
        setPosts(posts => [...posts, ...data])
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderPosts = () => {
    return posts.map((post, index) => (
      <article key={index} className="post">
        {post.bannerImageUrl && (
          <img src={post.bannerImageUrl}
            alt={post.title}
            title={post.title} />
        )}
        <p><em>Published on: {post.date}</em></p>
        <h2>{post.title}</h2>
        <h4>{post.subtitle}</h4>
        <div dangerouslySetInnerHTML={{ __html: post.bodyHtml }} />
      </article>
    ))
  }

  const loadMore = () => {
    setLoading(true)
    fetchPosts(BASE_URL, loadingIndex)
      .then(data => {
        setLoadingIndex(index => index - 5)
        setLoading(false)
        setPosts(posts => [...posts, ...data])
      })
  }

  const renderLoadMore = () => {
    if ( loadingIndex <= 0 ) { return }
    return (
      <button onClick={loadMore} disabled={loading}>
        {loading ? "Loading..." : "Load More"}
      </button>
    )
  }

  return (
    <div className="posts">
      {renderPosts()}
      {renderLoadMore()}
    </div>
  )
}


export default Posts
